export const REQUEST_SIZE_LIMIT = 1000;
export const NAME = 'taskPartnerSearch';
